import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.error-flag.title.non-final',
		defaultMessage: 'Unknown error',
		description: 'Title for the error flag if copying conflicted page fails',
	},
	errorFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.error-flag.description.non-final',
		defaultMessage: 'A copy of your offline page was unable to be created. Please try again.',
		description: 'Description for the error flag if copying conflicted page fails',
	},
	copyCreatedFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.title.non-final',
		defaultMessage: 'Copy created',
		description: 'Title for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.description.non-final',
		defaultMessage: 'A copy of your offline page was created.',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	copyCreatedFlagViewPage: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link.non-final',
		defaultMessage: 'View copied page',
		description: 'Description for the flag if copying conflicted page is successful',
	},
	createCopyFlagTitle: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.title.non-final',
		defaultMessage: 'Potential sync issue',
		description:
			'Title for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagDescription: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.description.non-final',
		defaultMessage: 'A conflict may have occurred while syncing the page.',
		description:
			'Description for the flag to warn and allow copy if a conflicted page is detected on reconnection',
	},
	createCopyFlagCreateAction: {
		id: 'editor-presets.conflict-resolution-plugin.copy-page.create-copy-flag.create-action.non-final',
		defaultMessage: 'Create copy of offline page',
		description:
			'Action in a flag to create a copy of the page if a conflicted page is detected on reconnection',
	},
});
